<template>
  <!-- Explore by Itinerary, Country Level -->
  <!-- Show list of Itineraries -->
  <div id="itinerary-list-container">
    <div
      class="itinerary-wrapper"
      v-for="entry in itineraries"
      :key="entry.thisId"
    >
      <div
        class="itinerary-image"
        :style="{ backgroundImage: 'url(' + entry.itineraryImage + ')' }"
      ></div>
      <div class="itinerary-info">
        <div class="itinerary-name">{{ entry.name }}</div>
        <div
          class="itinerary-description"
          v-if="entry.displayDescription"
          v-html="truncate(400, entry.description)"
        ></div>
        <div class="subs-link-wrapper">
          <router-link
            :to="{
              name: 'itineraries',
              params: {
                country: current.countryId
                  ? `c-${current.countryId}`
                  : $route.params.country
                  ? $route.params.country
                  : current.countryId,
                territory: current.territoryId
                  ? `tr-${current.territoryId}`
                  : current.territoryId,
                itinerary: `i-${entry.itineraryId}`,
              },
            }"
          >
            Read More
          </router-link>
        </div>
        <!-- Books and Tours are different format, doesn't use component -->
        <div class="itinerary-book" v-if="entry.mwnfTravelBook.length > 0">
          <div class="itinerary-book-label">
            Related Featured
            <span v-if="entry.mwnfTravelBook.length > 1">Books</span>
            <span v-else>Book</span>
          </div>
          <div
            class="itinerary-book-link"
            v-for="book in entry.mwnfTravelBook"
            :key="returnValueInLanguage('en', book).bookId"
          >
            <a
              :href="returnValueInLanguage('en', book).readMore"
              target="_blank"
            >
              {{ returnValueInLanguage("en", book).title }}
            </a>
          </div>
        </div>
        <div class="itinerary-tour" v-if="entry.mwnfTour.length > 0">
          <div class="itinerary-tour-label">
            Related MWNF
            <span v-if="entry.mwnfTour.length > 1">Tours</span>
            <span v-else>Tour</span>
          </div>
          <div
            class="itinerary-tour-link"
            v-for="tour in entry.mwnfTour"
            :key="returnValueInLanguage('en', tour).tourId"
          >
            <a
              :href="returnValueInLanguage('en', tour).readMore"
              target="_blank"
            >
              {{ returnValueInLanguage("en", tour).title
              }}<span v-if="returnValueInLanguage('en', tour).subtitle"
                >, {{ returnValueInLanguage("en", tour).subtitle }}</span
              >
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import language from "../mixins/language.js";
import truncate from "../mixins/truncate.js";
export default {
  name: "ItineraryList",
  mixins: [language, truncate],
  props: ["current", "next"],
  watch: {
    current() {},
    next() {
      this.setDescriptions(this.next);
    },
  },
  data() {
    return {
      itineraries: [],
    };
  },
  methods: {
    setDescriptions: function (next) {
      this.itineraries = this.next;
      // For every Itinerary in the Country
      for (let i = 0; i < next.length; i++) {
        // Check if the description exists
        if (
          next[i].itineraryDescription &&
          next[i].itineraryDescription.length > 0
        ) {
          // Check if English is available
          if (
            this.returnValueInLanguage(
              "en",
              next[i].itineraryDescription[0].details
            )
          ) {
            // Set description to English text
            this.itineraries[i].description = this.returnValueInLanguage(
              "en",
              next[i].itineraryDescription[0].details
            ).description;
            // Else, use first available language other than English
          } else {
            // Set to [0] of details as it would be the first
            this.itineraries[i].description =
              next[i].itineraryDescription[0].details[0].description;
          }
          // Set display to true for description
          this.itineraries[i].displayDescription = true;
          // Else there is no description
        } else {
          this.itineraries[i].displayDescription = false;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
#itinerary-list-container {
  width: 100%;
}

.itinerary-wrapper {
  display: flex;
  width: 100%;
  box-shadow: 0px 2px 8px $light-grey;
  margin-bottom: 20px;
}
.itinerary-image {
  height: 500px;
  width: 30%;
  background-color: $dark-green;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 10px;
}
.itinerary-info {
  width: 70%;
  padding: 30px;
  margin-left: 10px;
}

.itinerary-name {
  @include headings;
  @include font-size-3;
  margin-bottom: 10px;
}
.subs-link-wrapper {
  @include flex-center;
  height: 40px;
  width: 100%;
  background-color: $dark-green;
  border-radius: 10px;
  margin-bottom: 20px;
}
.subs-link-wrapper a {
  @include flex-center;
  @include headings;
  @include font-size-5;
  height: 100%;
  width: 100%;
  color: white;
  text-decoration: none;
}
.itinerary-description,
.itinerary-book,
.itinerary-tour {
  @include texts;
  @include font-size-6;
  margin-bottom: 20px;
}
.itinerary-description :deep(*) {
  @include texts;
  @include font-size-6;
}
.itinerary-book-label,
.itinerary-tour-label,
.itinerary-book-label span,
.itinerary-tour-label span {
  @include texts;
  @include font-size-6;
  font-weight: bold;
}
.itinerary-book-link,
.itinerary-tour-link {
  margin-top: 5px;
}
.itinerary-book-link a,
.itinerary-tour-link a,
.itinerary-tour-link span {
  @include texts;
  @include font-size-6;
  color: $dark-green;
}

@media only screen and (max-width: 899px) {
  .itinerary-image {
    height: 400px;
  }
  .itinerary-name {
    @include font-size-4;
  }
  .subs-link-wrapper a {
    @include font-size-6;
  }
  .itinerary-description,
  .itinerary-description :deep(*),
  .itinerary-book,
  .itinerary-tour {
    @include font-size-7;
  }
  .itinerary-book-label,
  .itinerary-tour-label,
  .itinerary-book-label span,
  .itinerary-tour-label span {
    @include font-size-7;
  }
  .itinerary-book-link a,
  .itinerary-tour-link a,
  .itinerary-tour-link span {
    @include font-size-7;
  }
}

@media only screen and (max-width: 749px) {
  .itinerary-wrapper {
    flex-direction: column;
  }
  .itinerary-image {
    height: 300px;
    width: 100%;
    background-size: contain;
  }
  .itinerary-info {
    width: 100%;
    margin-left: 0;
  }
}

@media only screen and (max-width: 499px) {
  .itinerary-image {
    height: 200px;
  }
  .subs-link-wrapper a {
    @include font-size-7;
    text-align: center;
  }
}
</style>
